import { createTabPageDescriptor } from "@/lib/tabs/pageDescriptorUtils";

export const ADMIN_TAB_PAGES = {
  ApiKeysPage: createTabPageDescriptor(
    "ApiKeysPage",
    () => import("@/components/pages/admin/ApiKeys/ApiKeysPage"),
  ),
  ApiKeyCreatePage: createTabPageDescriptor(
    "ApiKeyCreatePage",
    () => import("@/components/pages/admin/ApiKeys/ApiKeyCreatePage"),
  ),
  ApiKeyEditPage: createTabPageDescriptor(
    "ApiKeyEditPage",
    () => import("@/components/pages/admin/ApiKeys/ApiKeyEditPage"),
  ),
  AdminCompaniesPage: createTabPageDescriptor(
    "AdminCompaniesPage",
    () =>
      import("@/components/pages/admin/CompaniesPage/AdminCompaniesPage"),
  ),
  AdminCompanyPage: createTabPageDescriptor(
    "AdminCompanyPage",
    () => import("@/components/pages/admin/CompaniesPage/AdminCompanyPage"),
  ),
  AdminExternalInvitesPage: createTabPageDescriptor(
    "AdminExternalInvitesPage",
    () =>
      import("@/components/pages/admin/CompaniesPage/AdminExternalInvitesPage"),
  ),
  AdminLogsPage: createTabPageDescriptor(
    "AdminLogsPage",
    () => import("@/components/pages/admin/LogsPage/AdminLogsPage"),
  ),
  MarketplaceOverviewPage: createTabPageDescriptor(
    "MarketplaceOverviewPage",
    () =>
      import("@/components/pages/admin/Marketplace/MarketplaceOverviewPage"),
  ),
  AdminNewsOverviewPage: createTabPageDescriptor(
    "AdminNewsOverviewPage",
    () => import("@/components/pages/admin/News/AdminNewsOverviewPage"),
  ),
  AdminNewsArticleEditPage: createTabPageDescriptor(
    "AdminNewsArticleEditPage",
    () => import("@/components/pages/admin/News/AdminNewsArticleEditPage"),
  ),
  AdminNewsFacetEditPage: createTabPageDescriptor(
    "AdminNewsFacetEditPage",
    () => import("@/components/pages/admin/News/AdminNewsFacetEditPage"),
  ),
  MarketplaceSectionEditPage: createTabPageDescriptor(
    "MarketplaceSectionEditPage",
    () =>
      import("@/components/pages/admin/Marketplace/MarketplaceSectionEditPage"),
  ),
  MarketplaceServiceEditPage: createTabPageDescriptor(
    "MarketplaceServiceEditPage",
    () =>
      import("@/components/pages/admin/Marketplace/MarketplaceServiceEditPage"),
  ),
  MarketplacePartnerEditPage: createTabPageDescriptor(
    "MarketplacePartnerEditPage",
    () =>
      import("@/components/pages/admin/Marketplace/MarketplacePartnerEditPage"),
  ),
  MarketplacePartnerPageEditPage: createTabPageDescriptor(
    "MarketplacePartnerPageEditPage",
    () =>
      import(
        "@/components/pages/admin/Marketplace/MarketplacePartnerPageEditPage"
      ),
  ),
  MarketplaceTranslationsPage: createTabPageDescriptor(
    "MarketplaceTranslationsPage",
    () =>
      import("@/components/pages/admin/Marketplace/MarketplaceTranslationsPage"),
  ),
  MarketplaceFacetEditPage: createTabPageDescriptor(
    "MarketplaceFacetEditPage",
    () =>
      import("@/components/pages/admin/Marketplace/MarketplaceFacetEditPage"),
  ),
  AdminTranslationsPage: createTabPageDescriptor(
    "AdminTranslationsPage",
    () =>
      import("@/components/pages/admin/Translations/AdminTranslationsPage"),
  ),
  AdminExternalUserPage: createTabPageDescriptor(
    "AdminExternalUserPage",
    () => import("@/components/pages/admin/Users/AdminExternalUserPage"),
  ),
  AdminExternalUsersPage: createTabPageDescriptor(
    "AdminExternalUsersPage",
    () => import("@/components/pages/admin/Users/AdminExternalUsersPage"),
  ),
  AdminInternalUserPage: createTabPageDescriptor(
    "AdminInternalUserPage",
    () => import("@/components/pages/admin/Users/AdminInternalUserPage"),
  ),
  AdminMarketplacePartnerUserPage: createTabPageDescriptor(
    "AdminMarketplacePartnerUserPage",
    () =>
      import("@/components/pages/admin/Users/AdminMarketplacePartnerUserPage"),
  ),
  AdminInternalUsersPage: createTabPageDescriptor(
    "AdminInternalUsersPage",
    () => import("@/components/pages/admin/Users/AdminInternalUsersPage"),
  ),
  InternalInvitesPage: createTabPageDescriptor(
    "InternalInvitesPage",
    () => import("@/components/pages/admin/Users/InternalInvitesPage"),
  ),
  UserCompanyPage: createTabPageDescriptor(
    "UserCompanyPage",
    () => import("@/components/pages/admin/UserCompanyPage/UserCompanyPage"),
  ),
};
